
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bAfzr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1fOao = parcelRequire("1fOao");


var $kT5zt = parcelRequire("kT5zt");





var $2SlZp = parcelRequire("2SlZp");


var $eyWa4 = parcelRequire("eyWa4");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");








var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $gj7hi = parcelRequire("gj7hi");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $b3j2Y = parcelRequire("b3j2Y");





var $gfIPU = parcelRequire("gfIPU");


var $9SK6S = parcelRequire("9SK6S");





var $jXEWW = parcelRequire("jXEWW");

const $b5d0b0d9ee119881$var$i18n = (0, $cgtv4.defineMessages)({
    emptyAutomationModalAdminDescription: {
        id: "automation-menu.modal.empty.automations.admin.description",
        defaultMessage: "Use the manual trigger to populate a menu of selections that anyone, or people you specify, can apply as one-click automations to a page."
    },
    emptyAutomationsUserDescription: {
        id: "automation-menu.modal.empty.automations.user.description",
        defaultMessage: "Admins haven\u2019t configured any page automations for this space yet. When they do, it might include one-click actions like changing page restrictions."
    },
    learnMoreLink: {
        id: "automation-menu.empty-state.learn-more.link",
        defaultMessage: "Learn more about the manual trigger"
    },
    emptyAutomationListImageAlt: {
        id: "automation-menu.empty-state.image.alt",
        defaultMessage: "Empty automation list image"
    }
});
const $b5d0b0d9ee119881$var$emptyStateStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.500'
});
const $b5d0b0d9ee119881$var$imageStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.050',
    marginBottom: 'space.300'
});
const $b5d0b0d9ee119881$var$descriptionStyles = (0, $ecnYn.xcss)({
    width: '360px',
    textAlign: 'center'
});
const $b5d0b0d9ee119881$export$6875eeaa0fa7363c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { spaceKey: spaceKey, analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    const { canManageAutomations: canManageAutomations, error: permissionServiceError } = (0, $jXEWW.useAutomationPermissionService)(spaceKey);
    const descriptionContent = canManageAutomations ? $b5d0b0d9ee119881$var$i18n.emptyAutomationModalAdminDescription : $b5d0b0d9ee119881$var$i18n.emptyAutomationsUserDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b5d0b0d9ee119881$var$emptyStateStyles,
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b5d0b0d9ee119881$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: formatMessage($b5d0b0d9ee119881$var$i18n.emptyAutomationListImageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9SK6S)))
    })), permissionServiceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: permissionServiceError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
        error: permissionServiceError,
        attributes: {
            location: 'emptyState',
            source: analyticsSource
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b5d0b0d9ee119881$var$descriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), descriptionContent), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        spacing: "none",
        href: "https://www.atlassian.com/platform/automation",
        target: "_blank",
        onClick: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'learnMore',
                    source: analyticsSource
                }
            }).fire();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b5d0b0d9ee119881$var$i18n.learnMoreLink)))));
};









var $56M4r = parcelRequire("56M4r");


var $9hlns = parcelRequire("9hlns");











const $db84ea11aa8c2ada$var$ruleButtonStyle = (0, $ecnYn.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'radius.small'
});
const $db84ea11aa8c2ada$var$selectedRuleButtonStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest',
    borderColor: 'color.border.accent.blue',
    borderStyle: 'solid',
    borderWidth: 'border.width.selected',
    borderRadius: 'radius.small'
});
const $db84ea11aa8c2ada$var$ruleNameStyle = (0, $ecnYn.xcss)({
    // Using this to increase the height of the button itself.
    height: '28px'
});
const $db84ea11aa8c2ada$export$5f0f1183c836984b = ({ rule: rule, selectedRuleId: selectedRuleId, setSelectedRuleId: setSelectedRuleId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { analyticsSource: analyticsSource, invokingRuleId: invokingRuleId } = (0, $1fOao.useAutomationMenu)();
    const isSelectedRule = selectedRuleId === rule.id;
    const isExecuting = rule.id === invokingRuleId;
    const ruleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'selectManualTriggerAutomation',
                source: analyticsSource,
                attributes: {
                    ruleId: rule.id.toString()
                }
            }
        }).fire();
        setSelectedRuleId(rule.id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isSelectedRule ? $db84ea11aa8c2ada$var$selectedRuleButtonStyle : $db84ea11aa8c2ada$var$ruleButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        isDisabled: !!invokingRuleId,
        iconBefore: isExecuting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }) : null,
        onClick: ruleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $db84ea11aa8c2ada$var$ruleNameStyle,
        alignBlock: "center"
    }, rule.name)));
};


const $d4ab595ed4722bec$export$8e77116ea9034760 = ({ selectedRuleId: selectedRuleId, setSelectedRuleId: setSelectedRuleId })=>{
    const { rules: rules, analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
            attributes: {
                source: analyticsSource,
                ruleCount: rules.length
            }
        });
    }, [
        experienceTracker,
        analyticsSource,
        rules.length
    ]);
    if (rules.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5d0b0d9ee119881$export$6875eeaa0fa7363c), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, rules.map((rule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db84ea11aa8c2ada$export$5f0f1183c836984b), {
            key: `manual-rule-${rule.id}`,
            rule: rule,
            selectedRuleId: selectedRuleId,
            setSelectedRuleId: setSelectedRuleId
        }))));
};



























var $eSBnW = parcelRequire("eSBnW");




const $6677b9d7ee6df920$var$i18n = (0, $cgtv4.defineMessages)({
    errorDescription: {
        id: "automation-menu.modal.error.description",
        defaultMessage: "This is taking awhile to load. Try refreshing the page."
    },
    errorImageAlt: {
        id: "automation-menu.modal.error.image.alt",
        defaultMessage: "Error image"
    }
});
const $6677b9d7ee6df920$var$errorStateStyles = (0, $ecnYn.xcss)({
    textAlign: 'center',
    marginTop: 'space.500'
});
const $6677b9d7ee6df920$var$imageContainerStyles = (0, $ecnYn.xcss)({
    display: 'block',
    maxWidth: '116px',
    maxHeight: '156px',
    marginBottom: 'space.300',
    marginTop: 'space.050'
});
const $6677b9d7ee6df920$var$descriptionStyles = (0, $ecnYn.xcss)({
    maxWidth: '360px'
});
const $6677b9d7ee6df920$export$99d5fcf082612abf = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    (0, $42omo.useEffect)(()=>{
        experienceTracker.fail({
            name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
            error: new Error('Failed to fetch manual rules'),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker,
        analyticsSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $6677b9d7ee6df920$var$errorStateStyles,
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6677b9d7ee6df920$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: formatMessage($6677b9d7ee6df920$var$i18n.errorImageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eSBnW)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6677b9d7ee6df920$var$descriptionStyles
    }, formatMessage($6677b9d7ee6df920$var$i18n.errorDescription)));
};


const $ee2730b2a96335c8$export$7fe81a1a9142c622 = ({ selectedRuleId: selectedRuleId, setSelectedRuleId: setSelectedRuleId })=>{
    const { triggerFetch: triggerFetch, initialised: initialised, rules: rules, error: error, aris: aris } = (0, $1fOao.useAutomationMenu)();
    (0, $42omo.useEffect)(()=>{
        triggerFetch();
    // Want to ensure that triggerFetch is only called once when the component is mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (aris.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kT5zt.Skeleton), {
        lineCount: 10
    });
    if (!initialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kT5zt.Skeleton), {
        lineCount: 10
    });
    else if (error && rules.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6677b9d7ee6df920$export$99d5fcf082612abf), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d4ab595ed4722bec$export$8e77116ea9034760), {
        selectedRuleId: selectedRuleId,
        setSelectedRuleId: setSelectedRuleId
    });
};
module.exports["AutomationModalBody"] = $ee2730b2a96335c8$export$7fe81a1a9142c622;

});

parcelRegister("9SK6S", function(module, exports) {
module.exports = new URL("empty-automation-list.9c7d0496.png", import.meta.url).toString();

});

parcelRegister("eSBnW", function(module, exports) {
module.exports = new URL("error.b6351f9e.svg", import.meta.url).toString();

});

parcelRegister("gRtNT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $1fOao = parcelRequire("1fOao");


var $jXEWW = parcelRequire("jXEWW");

const $4dfde97d0570aaab$var$i18n = (0, $cgtv4.defineMessages)({
    modalFooterCancelButton: {
        id: "automation-menu.modal.footer.cancel-button",
        defaultMessage: "Cancel"
    },
    modalFooterAutomateButton: {
        id: "automation-menu.modal.footer.automate-button",
        defaultMessage: "Automate"
    },
    modalFooterCreateAutomationButton: {
        id: "automation-menu.modal.footer.get-started-button",
        defaultMessage: "Create automation"
    },
    modalFooterOkButton: {
        id: "automation-menu.modal.footer.ok-button",
        defaultMessage: "Ok"
    }
});
const $4dfde97d0570aaab$export$8bebd64914280cf9 = ({ selectedRuleId: selectedRuleId, onClose: onClose, inRovoButton: inRovoButton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { spaceKey: spaceKey, aris: aris, initialised: initialised, invokeRuleOrShowDialog: invokeRuleOrShowDialog, invokingRuleId: invokingRuleId, rules: rules, error: error, baseAutomationUrl: baseAutomationUrl, analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    const { canManageAutomations: canManageAutomations, error: permissionServiceError } = (0, $jXEWW.useAutomationPermissionService)(spaceKey);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Just to signal undesired footer results due to permission service failing.
    (0, $42omo.useEffect)(()=>{
        if (permissionServiceError) experienceTracker.fail({
            name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
            error: permissionServiceError,
            attributes: {
                source: analyticsSource,
                location: 'footer'
            }
        });
    }, [
        experienceTracker,
        analyticsSource,
        permissionServiceError
    ]);
    const sendFooterAnalyticsEvent = (actionSubjectId, ruleId)=>{
        const event = createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                source: analyticsSource
            }
        });
        if (ruleId) event.payload.data.attributes = {
            ruleId: ruleId
        };
        event.fire();
    };
    const okButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        key: "automation-modal-footer-ok",
        appearance: "primary",
        onClick: ()=>{
            sendFooterAnalyticsEvent('ok');
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4dfde97d0570aaab$var$i18n.modalFooterOkButton));
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        key: "automation-modal-footer-cancel",
        appearance: "subtle",
        onClick: ()=>{
            sendFooterAnalyticsEvent('cancel');
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4dfde97d0570aaab$var$i18n.modalFooterCancelButton));
    const createAutomationButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        key: "automation-modal-footer-create-automation",
        appearance: "primary",
        href: `${baseAutomationUrl}#rule/new`,
        onClick: ()=>{
            sendFooterAnalyticsEvent('createAutomation');
        },
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4dfde97d0570aaab$var$i18n.modalFooterCreateAutomationButton));
    const automateButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        key: "automation-modal-footer-automate",
        appearance: "primary",
        onClick: ()=>{
            if (selectedRuleId) {
                sendFooterAnalyticsEvent('executeManualTriggerAutomation', selectedRuleId.toString());
                invokeRuleOrShowDialog(selectedRuleId, aris.map(String));
            }
        },
        isDisabled: !selectedRuleId || !!invokingRuleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4dfde97d0570aaab$var$i18n.modalFooterAutomateButton));
    const modalButtons = [];
    if (!initialised) return null;
    // Populated rule list -> cancel and automate buttons
    // Empty admin scenario -> cancel and Create Automation buttons
    // Empty end user and error scenario -> Ok button
    if (rules.length < 1) {
        if (error || !canManageAutomations) modalButtons.push(okButton);
        else modalButtons.push(cancelButton, createAutomationButton);
    } else modalButtons.push(cancelButton, automateButton);
    // Don't show cancel and Ok button in Rovo Button experience
    if (inRovoButton) {
        const okIndex = modalButtons.indexOf(okButton);
        const cancelIndex = modalButtons.indexOf(cancelButton);
        if (okIndex > -1) modalButtons.splice(okIndex, 1);
        if (cancelIndex > -1) modalButtons.splice(cancelIndex, 1);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, modalButtons);
};
module.exports["AutomationModalFooter"] = $4dfde97d0570aaab$export$8bebd64914280cf9;

});

parcelRegister("5OHon", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9ot3w = parcelRequire("9ot3w");

var $804cB = parcelRequire("804cB");


var $7hXDW = parcelRequire("7hXDW");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $Ij2L0 = parcelRequire("Ij2L0");


var $1fOao = parcelRequire("1fOao");

const $3cdf698150a3fbb9$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    modalHeaderIconLabel: {
        id: "automation-menu.modal.header.icon.label",
        defaultMessage: "Automation modal header icon"
    },
    modalHeaderTitle: {
        id: "automation-menu.modal.header.title",
        defaultMessage: "Automate"
    },
    modalHeaderLearnMore: {
        id: "automation-menu.modal.header.learn-more",
        defaultMessage: "Learn more about manual triggers"
    },
    modalHeaderContextHint: {
        id: "automation-menu.modal.header.context-hint",
        defaultMessage: "Apply an automation to <b>{contentTitle}</b>."
    },
    modalHeaderContextDescription: {
        id: "automation-menu.modal.header.description",
        defaultMessage: "The available selections are controlled by Confluence and space administrators."
    }
});
const $3cdf698150a3fbb9$var$iconStyle = (0, $ecnYn.xcss)({
    marginRight: 'space.150',
    backgroundColor: 'color.background.accent.green.subtlest',
    borderRadius: 'radius.small'
});
const $3cdf698150a3fbb9$var$contextHintStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $3cdf698150a3fbb9$export$918c7c2e2d7f0bfd = ({ contentTitle: contentTitle, modalTitle: modalTitle })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { initialised: initialised, rules: rules } = (0, $1fOao.useAutomationMenu)();
    const { titleId: titleId } = (0, $804cB.useModal)();
    const showHint = initialised && rules.length > 0;
    const contextHint = formatMessage($3cdf698150a3fbb9$export$a7357cdd1f0b0168.modalHeaderContextHint, {
        contentTitle: contentTitle,
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3cdf698150a3fbb9$var$iconStyle,
        paddingInline: "space.050",
        paddingBlock: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Ij2L0.ManualTriggerIcon), {
        size: "small",
        label: formatMessage($3cdf698150a3fbb9$export$a7357cdd1f0b0168.modalHeaderIconLabel),
        primaryColor: "var(--ds-icon-accent-green, #22A06B)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium",
        id: titleId
    }, modalTitle)), showHint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3cdf698150a3fbb9$var$contextHintStyle
    }, contextHint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, formatMessage($3cdf698150a3fbb9$export$a7357cdd1f0b0168.modalHeaderContextDescription)))));
};
module.exports["i18n"] = $3cdf698150a3fbb9$export$a7357cdd1f0b0168;
module.exports["AutomationModalHeader"] = $3cdf698150a3fbb9$export$918c7c2e2d7f0bfd;

});


//# sourceMappingURL=PageQuickActionAutomationMenu.433c6c0b.js.map
